import { useScopedSelector } from 'ia-react-core';
import React from 'react';
import { MessagingSummaryResourceInfo } from '../components/MessagingSummaryResource/MessagingSummaryResource';
import SecuredMessagingSideNavLink from '../components/SecuredMessagingSideNavLink';
import Constants from '../Constants';

const useDocumentsNavLinks = () => {
  const newMessageCount: number = useScopedSelector(MessagingSummaryResourceInfo.dataDst);
  return (newMessageCount > 0 || newMessageCount === 0) ? [<SecuredMessagingSideNavLink key="MyMessages" path={Constants.BasePagePath} />] : [];
};

export default useDocumentsNavLinks;
